import useDetails from '../hooks/useDetails';
import InputComp from 'components/InputComp';
import InputCustom from './InputCustom';
import { Col, Row } from 'antd';
import "../../../styles/AditionalInfo.css"
import useForm from 'hooks/useForm';
import { useEffect, useState } from 'react';
import ButtonIcon from 'components/ButtonComp';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { updateAssets, uploadInventoryInvoiceFiles } from 'api/its/assets';
import { useNotificationContext } from 'services/NotificationContext';
import usePagination from 'hooks/usePagination'
import { IAsset } from 'models/Assets'

interface AditionalInfoProps {
    entries: [string, any][]
    asset_id: number
    project_id: number,
    onClose: () => void,
    hookAssets: ReturnType<typeof usePagination<IAsset>>
}

const AditionalInfo = ({ entries, asset_id, project_id, onClose, hookAssets }: AditionalInfoProps) => {
    const { getNewValues, getType, getLabel, getSelect } = useDetails();
    const { form, handleChange, setForm, file } = useForm<Record<string, any>>({});
    const [InitialState] = useState(Object.fromEntries(entries.filter(([key]) => getNewValues(key))))
    const [body] = useState(Object.fromEntries(entries.filter(([key]) => key)))
    const [ShowButtonUpdate, setShowButtonUpdate] = useState(false)
    const { show } = useNotificationContext();
    const [ Loading, setLoading ] = useState(false)

    useEffect(() => {
        validateChanges()
    }, [form, file]);

    const validateChanges = () => {
        const changes = handleUpdate();
        if (Object.keys(changes).length || file) {
            setShowButtonUpdate(true)
        } else {
            setShowButtonUpdate(false)
        }
    }

    const handleUpdate = () => {
        const updatedFields: Record<string, any> = {};

        for (const key in form) {
            if (form.hasOwnProperty(key)) {
                const initialValue = InitialState[key];
                const currentValue = form[key];
                if (currentValue != initialValue) {
                    updatedFields[key] = currentValue;
                }
            }
        }

        return updatedFields;
    };

    const handleSubmit = async () => {
        setLoading(true)
        setShowButtonUpdate(false)
        const data = handleUpdate();

        if (file) {
            const data = new FormData();
            data.append('invoice_file', file);
            let resposeFile = await uploadInventoryInvoiceFiles({
                data,
                id: asset_id,
                table: 'assets_its',
                project_id: `${project_id}`
            })

            if (!Object.keys(data).length) {
                if (resposeFile) {
                    show(
                        'success',
                        '¡Operación satisfactoria!',
                        'El documento se ha actualizado de manera satisfactoria.',
                    );
                } else {
                    show(
                        'error',
                        '¡Operación fallida!',
                        'Ha ocurrido un error al tratar de actualizar el documento',
                    );
                }
                /* llamar reload */
                setLoading(false)
                onClose()
                return
            }
        }

        let response = await updateAssets({
            table: 'assets_its',
            project_id,
            data,
            id: asset_id
        })

        if (response) {
            //@ts-ignore
            hookAssets.updateElement({...body,...data})

            show(
                'success',
                '¡Operación satisfactoria!',
                'La información ha sido actualizada de manera satisfactoria.'
            );
        } else {
            show(
                'success',
                '¡Operación satisfactoria!',
                'Ha ocurrido un error al tratar de actualizar la información.'
            );
        }
        /* llamar reload */

        onClose()
        setLoading(false)
    };

    const handleSelect = (val: string, name: string) => setForm({ ...form, [name]: val })

    return (
        <div className={`${Loading ? "sending__data__info" :""} `} >
            <Row gutter={16}>
                {
                    entries
                        .filter(([key]) => getNewValues(key))
                        .map(([key, value]) => {
                            const type = getType(key)
                            const label = getLabel(key);
                            const select = getSelect(key)

                            if (type === "number" || type === "text") {
                                return <Col key={key} xs={2} sm={4} md={6} lg={6} xl={12}>
                                    <InputComp
                                        title={label}
                                        name={key}
                                        value={form[key] || value}
                                        onChange={handleChange} />
                                </Col>
                            }

                            return <Col key={key} xs={2} sm={4} md={6} lg={6} xl={12}>
                                <InputCustom
                                    title={label} name={key} type={type ? type : ""}
                                    value={value}
                                    project_id={project_id}
                                    asset_id={asset_id} select={select?.length ? select : []}
                                    handleChange={handleChange}
                                    handleSelect={handleSelect}
                                />
                            </Col>

                        })
                }
            </Row>
            <div className='btn__update__extra' >
                {ShowButtonUpdate && <ButtonIcon name='Actualizar' icon={faSave} onClick={handleSubmit} variant='outline-primary' />}
            </div>
        </div>
    )
}

export default AditionalInfo